import { isNewIdentifiant, newIdentifiant } from '@mairistem/tools';
import BordereauStateType from '../../../constants/liquidation/bordereaux/BordereauStateType';
import ActionResultType from '../../../interfaces/pieces/ActionResultType';
import BordereauActionType from '../../../interfaces/pieces/bordereaux/BordereauActionType';
import type { BaseLiquidationOptions } from '../../../interfaces/pieces/mouvements/liquidation/BaseLiquidationOptions';
import type { BordereauWithState } from '../../../interfaces/pieces/TreeRow';
import type TreeviewActionResult from '../../../interfaces/pieces/TreeviewActionResult';
import BaseLiquidationAction from '../../pieces/BaseLiquidationAction';

class BordereauModifierAction extends BaseLiquidationAction<
	BordereauWithState,
	BordereauActionType
> {
	constructor(
		options: BaseLiquidationOptions & { isCreation?: boolean } = null,
	) {
		super(options);
		this.label = options?.isCreation ? 'Créer le bordereau' : 'Modifier';
		this.type = BordereauActionType.MODIFIER_BORDEREAU;
	}

	execute = (
		bordereau: BordereauWithState,
	): TreeviewActionResult<BordereauWithState> => ({
		type: ActionResultType.MODAL,
		result: Promise.resolve({
			...bordereau,
			identifiant: isNewIdentifiant(bordereau.identifiant)
				? newIdentifiant()
				: bordereau.identifiant,
		}),
		extraProps: {
			isSuperUser: this.isSuperUser,
			bordereauModal: {
				visible: true,
				typeAction: BordereauActionType.MODIFIER_BORDEREAU,
			},
		},
	});

	executeAction = (
		bordereau: BordereauWithState,
	): TreeviewActionResult<BordereauWithState> => ({
		type:
			bordereau.state.state === BordereauStateType.NOUVEAU
				? ActionResultType.ADD
				: ActionResultType.UPDATE,
		result: Promise.resolve(bordereau),
	});
}

export default BordereauModifierAction;
